exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".projects.card.small {\n  height: 213px !important; }\n\n.projects a {\n  color: #000000; }\n\n.card.card-content {\n  padding: 16px 24px; }\n\n.indicatorName {\n  line-height: 1em;\n  font-size: 0.8em; }\n\n.progressBackground {\n  background: white !important;\n  height: 2em; }\n\n.progressForeground1 {\n  background: #1594A6 !important; }\n\n.progressForeground2 {\n  background: #f1cb8f !important; }\n\n.progressLabel {\n  padding-top: 0.6em !important; }\n\n.progressRow {\n  vertical-align: middle;\n  line-height: 2em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/risk-indicator-card/risk-indicator-card.component.scss
// module id = ../../../../../src/app/components/risk-indicator-card/risk-indicator-card.component.scss
// module chunks = main